export enum Billing {
  billingArea = 'V',
  roomCostCenter = 'R',
  workPlace = 'A',
}
